// src/graphql/sector_rotation.js
import { gql } from "@apollo/client";

const SECTOR_ROTATION = gql`
  query GetSectorRotation(
    $holdingMonth: String!
    $holdingYear: String!
    $category: String
  ) {
    getSectorRotation(
      holdingMonth: $holdingMonth
      holdingYear: $holdingYear
      category: $category
    ) {
      sectorName
      flowDirection
      flowScore
      funds {
        mutualFundId
        mutualFundName
        totalChangeInPtHoldings
      }
    }
  }
`;

export default SECTOR_ROTATION;


